var Team = (function ($, waystar_params) {
  /** Adds a div around sections for modal */

  // Select the elements
  const sectionTabs = document.querySelector("section#tabs");
  const article = document.querySelector("article");

  // Create the opening and closing divs if they don't exist
  let overlayDiv = document.querySelector(".content-overlay");
  if (!overlayDiv) {
    overlayDiv = document.createElement("div");
    overlayDiv.className = "content-overlay";
    if (sectionTabs) {
      sectionTabs.insertAdjacentElement("afterend", overlayDiv);
    }
  }

  let closingDiv = document.querySelector(".content-overlay-end");
  if (!closingDiv) {
    closingDiv = document.createElement("div");
    closingDiv.className = "content-overlay-end";
    if (article) {
      article.appendChild(closingDiv);
    }
  }

  /* Ensure modal is placed within the overlay */

  var $modal = $(".js-content-overlay");
  var $hideLater = $(".hide-later");
  var $content = $modal.find(".js-content-overlay--content");
  var $close = $modal.find(".close-overlay");
  var $triggers = $('[data-control="overlay"]');

  if ($modal.length && overlayDiv) {
    overlayDiv.appendChild($modal[0]);
  }

  // Find the height of the header
  function getHeaderHeight() {
    const $header = $('#header');
    return $header.length ? $header.outerHeight() : 0;
  }

  // Update the modal height based and add position styles
  function updateModalHeight() {
    const headerHeight = getHeaderHeight();
    const modalHeight = `calc(100vh - ${headerHeight}px)`;

    $modal.css({
      position: "fixed",
      top: `${headerHeight}px`,
      left: 0,
      width: "100vw",
      height: modalHeight,
      overflowY: "auto",
      zIndex: 9999,
      opacity: "1",
      display: "block",
    });
  }
  // function updateModalHeight() {
  //   const $overlayStart = $(".content-overlay");
  //   const $overlayEnd = $(".content-overlay-end");
  //   const $modal = $(".js-content-overlay");

  //   // Check if the required elements exist
  //   if (!$overlayStart.length || !$overlayEnd.length || !$modal.length) {
  //     console.warn("Missing required elements.");
  //     return;
  //   }

  //   // Force reflow for the elements
  //   $overlayStart[0].offsetHeight;
  //   $overlayEnd[0].offsetHeight;

  //   // Get the top position of the start overlay and the bottom of the end overlay
  //   const overlayStartTop =
  //     $overlayStart[0].getBoundingClientRect().top + $(window).scrollTop();
  //   const overlayEndBottom =
  //     $overlayEnd[0].getBoundingClientRect().top + $(window).scrollTop();

  //   // Calculate the available overlay height
  //   let overlayHeight = overlayEndBottom - overlayStartTop;

  //   if (overlayHeight > 0) {
  //     // Apply the calculated height to the modal
  //     $modal.css({
  //       height: `${Math.min(overlayHeight, $(window).height())}px`,
  //       opacity: "1",
  //       display: "block",
  //     });

  //     // Ensure the content-overlay adjusts its height
  //     $overlayStart.css({
  //       height: `${Math.min(overlayHeight, $(window).height())}px`,
  //     });
  //   } else {
  //     console.warn(
  //       "Invalid overlay height calculated. Check element visibility or positioning."
  //     );
  //     console.log("overlayStart:", $overlayStart[0].getBoundingClientRect());
  //     console.log("overlayEnd:", $overlayEnd[0].getBoundingClientRect());
  //   }
  // }

  $triggers.each(function (index, item) {
    $(item).on("click", function (e) {
      var params = {
        team_id: $(e.currentTarget).attr("data-id"),
      };

      updateModalHeight();
      get_post(params);
      // $modal.show();
      $modal.addClass("show");
      $("body").addClass("modal-open");
      $hideLater.hide();
    });
  });

  // $close.on("click", function () {
  //   $modal.removeClass("show");
  //   $("body").removeClass("modal-open");
  //   $modal.hide();
  //   $hideLater.show();
  //   $content.html(""); // Clear modal content
  // });

  function closeModal() {
    $modal.removeClass("show");
    $("body").removeClass("modal-open");
    $modal.hide();
    $hideLater.show();
    $content.html(""); // Clear modal content
  }

  // Trigger on click
  $close.on("click", closeModal);

  // Also trigger on resize
  $(window).on("resize", closeModal);


  // Update on window resize to maintain correct positioning
  // $(window).resize(updateModalHeight);

  // var $body     = $('.content-overlay'),
  //     $modal    = $('.js-screen-overlay'),
  //     $content  = $modal.find('.js-screen-overlay--content'),
  //     $close    = $modal.find('.close-overlay'),
  //     $triggers = $('[data-control="overlay"]');

  // $triggers.each(function(index, item){
  //     $(item).on('click', function(e) {
  //         var params = {
  //             team_id: $(e.currentTarget).attr('data-id')
  //         };

  //         get_post(params);
  //         $modal.addClass('show d-block');
  //         $body.addClass('body-freeze');
  //     });
  // });

  // $close.on('click', function(e) {
  //     $modal.removeClass('show d-block');
  //     $body.removeClass('body-freeze');
  //     $content.html('');
  // });

  /**
   * Send ajax request to get post data
   * @param params
   */
  function get_post(params) {
    // Prepare request
    var request_data = $.extend(params, {
      _ajax_nonce: waystar_params.security,
      action: "team_bio",
    });

    // Request with data and update view
    $.get(waystar_params.endpoint, request_data, update_view);
  }

  /**
   * Update content with result
   * @param data
   */
  function update_view(data) {
    $content.html(data.result);
  }
})(jQuery, waystar_params);

// const sectionTabs = document.querySelector('section#tabs');
// const article = document.querySelector('article');

// // Create the opening and closing divs if they don't exist
// let overlayDiv = document.querySelector('.content-overlay');
// if (!overlayDiv) {
//   overlayDiv = document.createElement('div');
//   overlayDiv.className = 'content-overlay';
//   if (sectionTabs) {
//     sectionTabs.insertAdjacentElement('afterend', overlayDiv);
//   }
// }

// let closingDiv = document.querySelector('.content-overlay-end');
// if (!closingDiv) {
//   closingDiv = document.createElement('div');
//   closingDiv.className = 'content-overlay-end';
//   if (article) {
//     article.appendChild(closingDiv);
//   }
// }

// // Select elements
// const modal = document.querySelector('.js-screen-overlay');
// const modalContent = modal.querySelector('.js-screen-overlay--content');
// const closeModal = modal.querySelector('.close-overlay');
// const overlayStart = document.querySelector('.content-overlay');
// const overlayEnd = document.querySelector('.content-overlay-end');
// const triggers = document.querySelectorAll('[data-control="overlay"]');

// // Place modal between overlays
// if (overlayStart && overlayEnd) {
//   overlayEnd.parentNode.insertBefore(modal, overlayEnd);
// }

// // Open modal
// triggers.forEach(trigger => {
//   trigger.addEventListener('click', (e) => {
//     const teamId = e.currentTarget.getAttribute('data-id');
//     console.log('Team ID:', teamId); // Example for fetching data if needed
//     modal.style.display = 'flex';
//     document.body.classList.add('body-freeze');
//   });
// });

// // Close modal
// closeModal.addEventListener('click', () => {
//   modal.style.display = 'none';
//   document.body.classList.remove('body-freeze');
// });
